import { Link } from "react-router-dom";
import { ColumnDef, createColumnHelper} from "@tanstack/table-core";
import { getTableFormattedDate } from "../../helpers/date-time-helper";
import { TUser, TUserRole } from "../../common/types/user";

type TableUser = Pick<TUser, 'id' | 'displayName' | 'email' | 'created' | 'operatedDeviceCount' | 'appRoles'>;
type TValue = string | number | TUserRole[];

const columnHelper = createColumnHelper<TableUser>();

export const COLUMNS: ColumnDef<TableUser, TValue>[] = [
    columnHelper.accessor<'displayName', string>('displayName', {
        id: "displayName",
        header: "Name",
        cell: (props) => (
            <Link to={`${props.row.original.id}`}>
                {props.getValue()}
            </Link>
        ),
        enableColumnFilter: false,
    }),
    columnHelper.accessor<'appRoles', TUserRole[]>('appRoles', {
        id: 'appRoles',
        header: 'Roles',
        enableColumnFilter: false,
        cell: (props) => props.getValue().map(role => role.roleName).join(', '),
    }),
    columnHelper.accessor<'email', string>('email', {
        id: 'email',
        header: 'Email',
        enableColumnFilter: false,
    }),
    columnHelper.accessor<'created', string>('created', {
        id: 'created',
        header: 'User Since',
        enableColumnFilter: false,
        cell: (props) => getTableFormattedDate(props.getValue()),
    }),
    columnHelper.accessor<'operatedDeviceCount', any>('operatedDeviceCount', {
        id: 'operatedDeviceCount',
        header: 'Machine Count',
        enableColumnFilter: false,
        cell: (props) => props.getValue(),
    }),
];
